import { createSelector } from '@opengov/compose-app/reselect';
import { EQueryType } from '@opengov/reporting-types';

import { selectFeatureFlag } from '../feature-flag/launchDarkly/launchDarklySelectors';

import { ogqlState } from './state';

export const selectIsQueryCancelled = createSelector(
  ogqlState.selector,
  state => (id: string): boolean => !state.queries.some(q => q.id === id)
);

export const selectIsQueryRunning = createSelector(
  ogqlState.selector,
  state => (queryType: EQueryType) => state.queries.some(q => q.queryType === queryType)
);

const USE_FAST_RETURN = 'use-fast-return-in-next-gen-reports';

export const selectUseFastReturn = createSelector(
  selectFeatureFlag,
  getFeatureFlag => getFeatureFlag(USE_FAST_RETURN) || false
);

export const selectOgqlViews = createSelector(
  ogqlState.selector,
  state => state.views
);

export const selectOgqlViewsLoading = createSelector(
  ogqlState.selector,
  state => state.loadingViewList
);

const USE_QUERY_SERVICE = 'use-query-service-in-next-gen-reports';

export const selectUseQueryService = createSelector(
  selectFeatureFlag,
  getFeatureFlag => getFeatureFlag(USE_QUERY_SERVICE) || false
);
